/**
 * Runtime configuration.
 *
 *  - API base: `VITE_API_BASE` if set; otherwise `/eval` in production builds
 *    (same origin as https://pdfcollab.eoslightmedia.com/eval/…) and '' in dev,
 *    where the Vite dev server proxies `/api` and `/ws` to http://localhost:8000.
 *  - WebSocket base: derived from the API base (http→ws, https→wss; a relative
 *    base resolves against the page origin).
 */

const env = (import.meta as ImportMeta & { env?: Record<string, string | boolean | undefined> }).env ?? {};

export function apiBase(): string {
  const v = env.VITE_API_BASE;
  if (typeof v === 'string') return v.replace(/\/+$/, '');
  return env.PROD ? '/eval' : '';
}

export function wsBaseFor(api: string, origin = typeof location !== 'undefined' ? location.origin : 'http://localhost'): string {
  if (/^https?:\/\//i.test(api)) return api.replace(/^http/i, 'ws').replace(/\/+$/, '');
  return origin.replace(/^http/i, 'ws') + api;
}

export function wsBase(): string {
  const v = env.VITE_WS_BASE;
  if (typeof v === 'string' && v) return v.replace(/\/+$/, '');
  return wsBaseFor(apiBase());
}

/** True on a dev server or a localhost origin (QA login allowed). */
export function isDevOrigin(): boolean {
  if (env.DEV) return true;
  if (typeof location === 'undefined') return false;
  return ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname);
}

export const SERVICE_ACCOUNT_KEY: string =
  (typeof env.VITE_SERVICE_ACCOUNT_API_KEY === 'string' && env.VITE_SERVICE_ACCOUNT_API_KEY) ||
  'test-service-account-key-change-me';

/** Vite `base` of the running app ('/eval/excalidraw/' in production). */
export function appBase(): string {
  return typeof env.BASE_URL === 'string' ? env.BASE_URL : '/';
}
